export const TYPES = {
  GET_SERVICE_GROUP_SUCCESS: "service/GET_SERVICE_GROUP_SUCCESS",
  GET_SERVICE_LIST_SUCCESS: "service/GET_GROUP_LIST_SUCCESS",
  SELECT_SERVICE_SUCCESS: "service/SELECT_SERVICE_SUCCESS",
  SELECT_SERVICE_DATETIME_SUCCESS: "service/SELECT_SERVICE_DATETIME_SUCCESS",
  SELECT_SERVICE_STEP_SUCCESS: "service/SELECT_SERVICE_STEP_SUCCESS",
};
